function isHttpsLink(value: any): boolean {
  const httpsRegex = /^https:\/\//i;
  return httpsRegex.test(value);
}

export default isHttpsLink;
